import { Action } from '@ngrx/store';

import { UserRoleType } from '@digihaven/shared';

import { UserActions, UserActionTypes } from '@actions/user.actions';
import { FetchFromLocalStorage } from '@common/helpers/fetch-from-local-storage.helper';

import { UserState } from 'state';

const emptyState: UserState = {
    userInfo: {
        username: '',
        roleLabel: UserRoleType.EmptyRole,
        firstName: '',
        lastName: ''
    }
};

// If this breaks in offline mode, clear your localstorage
export const initialState: UserState = FetchFromLocalStorage('user') || emptyState;

export function userReducer(state = initialState, action: Action): UserState {
    const specificAction: UserActions = action as UserActions;

    switch (specificAction.type) {
        case UserActionTypes.Set:
            return { ...state, userInfo: specificAction.payload };
        case UserActionTypes.Unset:
            return { ...emptyState };
        default:
            return state;
    }
}
